/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  PublicPayeePayorsSearchCompaniesParams,
  PublicPayeePayorsSearchNamesParams,
  PublicPayeePayorsSearchNames2Params,
  SearchPayorsResponse,
  SearchPayorNamesResponse
 } from '../types';

  //  PublicPayeePayorsClient
class PublicPayeePayorsClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly searchCompanies = (queryParams: PublicPayeePayorsSearchCompaniesParams): AxiosPromise<SearchPayorsResponse> => {
        let url_ = "/api/v1/core/payee/payors";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly searchNames = (queryParams: PublicPayeePayorsSearchNamesParams): AxiosPromise<SearchPayorNamesResponse> => {
        let url_ = "/api/v1/core/payee/payors/name";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly searchNames2 = (queryParams: PublicPayeePayorsSearchNames2Params): AxiosPromise<SearchPayorNamesResponse> => {
        let url_ = "/public/api/v1/payee/payors/name";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// PublicPayeePayorsClient
  
export const publicPayeePayorsClient = new PublicPayeePayorsClient(baseClientConstructorProps);
